import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import EcoProButton from "../../../../../../components/shared/button/button";
import { BOSPageContext } from "../../../../BenefitOfSuppliesWrapper";
import convertHtmlToReact from "@hedgedoc/html-to-react";
import { NATIVE_APP_SELECTION_ATTRIBUTE } from "../../../../../../constants/AppConstants";
import BplusTermsAndConditionsLabel from "../../../../../../components/Web/Customer/BrotherPlus/TermsAndConditionsLabel/TermsAndConditionsLabel";

const Confirmation = () => {
    const { t } = useTranslation(["translation"]);
    
    const {
        handleGetStarted
    } = useContext(BOSPageContext);

     const [isTermsAndconditionsAgreed, setTermsAndConditionAgreed] = useState(false);
        const handleTermsAndConditions = (event) => {
            setTermsAndConditionAgreed(event.target.checked);
        }

    return (
        <>
            <h1 className="bplus-confirmation-card-header">{t('ECOPRO_BENEFIT_OF_SUPPLIES_PAGE.GETSTARTED_TXT')}</h1>
            <div className="benefit-points no-list-type bplus-confirmation-card-benefit-points">
                <ul>{convertHtmlToReact(t('BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.CONFIRMATION_PAGE.BENEFIT_POINTS'), [true])}</ul>
            </div>
            <div className="terms-and-conditions-container">
                <div className="terms-and-conditions check-box-wrapper">
                    <input type="checkbox" id="brother-plus-terms-conditions" onChange={handleTermsAndConditions} checked={isTermsAndconditionsAgreed}/>
                    <BplusTermsAndConditionsLabel GAText = "brotherplus-mobile-app-benefits-of-suuplies-terms-and-condition"/>
                </div>
            </div>
            <div className="continue-btn-container">
                 <EcoProButton cname="get-started-btn" disabled={(isTermsAndconditionsAgreed) ? false : true } onBtnClick={() => handleGetStarted(NATIVE_APP_SELECTION_ATTRIBUTE.BPLUS_SERVICE)}>{t('ECOPRO_BENEFIT_OF_SUPPLIES_PAGE.GETSTARTED_TXT')}</EcoProButton>
            </div>
        </>
    )
}

export default Confirmation;